import { ButtonComponentProps } from "@omni/ui/components/Button/button.props";
import { StyleType } from "@omni/ui/components/CallToAction/types/enums/styleType.enum";
import { Style } from "@omni/ui/components/CallToAction/types/style";
import { cn } from "@omni/utils/styles";

export const createButtonStyleProperties = (
    style: Style
):
    | Partial<{
          color: ButtonComponentProps["color"];
          outline: ButtonComponentProps["outline"];
          size: ButtonComponentProps["size"];
          fullWidth: ButtonComponentProps["fullWidth"];
          className: string;
      }>
    | undefined => {
    if (style.styleType === StyleType.BUTTON) {
        const { color: aemColor, outline, fullWidth, size } = style;

        const color = aemColor === "info" ? "information" : aemColor;

        return {
            color: color,
            outline: outline,
            fullWidth: fullWidth,
            size: size
        };
    }

    if (style.styleType === StyleType.TITLE) {
        const { color, underline, headingLevel } = style;

        const colorClass = color ? `text-${color}` : undefined;
        const underlineClass =
            underline === "always"
                ? "text-decoration-underline"
                : underline === "never"
                  ? "text-decoration-none"
                  : undefined;
        const headingClass = headingLevel ? `h${headingLevel}` : undefined;

        return {
            color: "link",
            className: cn(colorClass, underlineClass, headingClass)
        };
    }

    if (style.styleType === StyleType.LINK) {
        return {
            color: "link",
            className: "link"
        };
    }
};
